module.exports = __webpack_public_path__ + "img/error.cc532bf3.png";